import React from "react";
import { motion } from "framer-motion";
import { portfolioData } from "../data/portfolioData";

const Blog = () => {
  const { blogPosts, sections } = portfolioData;

  if (!blogPosts?.length) return null;

  return (
    <section id="blog" className="scroll-mt-24 py-14">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <h2 className="text-3xl font-bold text-slate-900">{sections.blogTitle}</h2>
        <div className="mt-8 grid gap-5 md:grid-cols-3">
          {blogPosts.map((post, index) => (
            <motion.article
              key={post.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
              className="rounded-xl border border-slate-200 bg-white/80 p-5 shadow-sm"
            >
              <h3 className="text-base font-semibold text-slate-900">{post.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-700">{post.summary}</p>
              <a
                href={post.link}
                target="_blank"
                rel="noreferrer"
                className="mt-4 inline-block text-sm font-semibold text-indigo-700 hover:text-indigo-600"
              >
                Read More
              </a>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
